import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { environment } from '../../../../environments/environment';
import { AuthLibService } from '../../services/auth/auth-lib.service';
import { AuthService } from '../../services/auth/auth.service';
import { TitleService } from '../../services/title.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, RouterLink, NzButtonComponent, NzIconDirective],
})
export class LoginComponent implements OnInit {
  private authLibService = inject(AuthLibService);
  private authService = inject(AuthService);
  private titleService = inject(TitleService);

  readonly siteUrl = environment.site_url;
  readonly year = new Date().getFullYear();
  isLoggedIn$: Observable<boolean> = this.authService.loginStateChange$;

  ngOnInit(): void {
    this.titleService.setTitle('Sign in');
  }

  /**
   * Sign-in is one navigation to the hosted auth page, so a plain click
   * handler is all the button needs.
   */
  login(): void {
    this.authLibService.showAuthModal();
  }

  logout(): void {
    this.authService.logout();
  }
}
